import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import noop from "lodash/noop";
/* eslint-disable no-console */

let warn = noop;

if (process.env.NODE_ENV !== 'production') {
  warn = () => {
    console.group('%cMisconfigured Union analytics', 'font-size: 16px;color:red');
    console.log('Global analytics is not configured correctly.');
    console.log('Please follow the instructions here: https://docs.union.theknot.com/docs/packages/@xo-union/tk-analytics"');
    console.groupEnd();
  };
}

const createWrapper = fnName => {
  const wrapper = function () {
    if (_globalThis.analytics) {
      _globalThis.analytics[fnName](...arguments);
    } else {
      warn();
    }
  };

  return wrapper;
};

export default {
  track: createWrapper('track'),
  alias: createWrapper('alias'),
  identify: createWrapper('identify'),
  reset: createWrapper('reset')
};